<template>
  <div class="profile" v-if="user">
    <v-tabs
      v-model="tab"
      background-color="blue"
      center-active
      dark
      centered
      fixed-tabs
      slider-color="blue darken-3"
      slider-size="3"
      elevation="2"
    >
      <v-tab>Datos básicos</v-tab>
      <v-tab>Datos complementarios</v-tab>
      <v-tab>Documentos</v-tab>
      <v-tab>
        <v-badge
          color="green"
          :content="user.notes.length > 0 ? user.notes.length : '0'"
        >
          Notas
        </v-badge>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <v-card-text v-if="user">
            <v-row class="text-left">
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Nombre:</span>
                {{ user.full_name }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Cédula:</span>
                {{ user.colombian_id }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Ciudad de expedición:</span
                >
                {{ user.employee.expedition_city }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Teléfono:</span>
                {{ user.phone }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Dirección:</span>
                {{ user.address }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Correo:</span>
                {{ user.email }}
              </v-col>
            </v-row>
            <v-row class="text-left" v-if="user.employee.charge_id">
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Cargo:</span>
                {{ user.employee.charge.name }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text v-if="user">
            <v-row class="text-left">
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold"
                  >Tipo de sangre:</span
                >
                {{ user.employee.blood_type }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold"
                  >Fecha de nacimiento:</span
                >
                {{ user.employee.birthday }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold">Eps:</span>
                {{ user.employee.eps }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold">Pensión:</span>
                {{ user.employee.pension }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold"
                  >Operador de pila (seguridad social):</span
                >
                {{ user.employee.stack_operator }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold"
                  >Correo segundario:</span
                >
                {{ user.employee.second_email }}
              </v-col>
              <v-col cols="12" md="4">
                <span class="black--text font-weight-bold">Teléfono fijo:</span>
                {{ user.employee.landline }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text v-if="user">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Nombre</th>
                    <th class="text-left">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-left">Foto</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.photo_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Propuesta</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.proposal_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Rut</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.rut_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Hoja de vida</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.cv_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Soportes de hoja de vida</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.cv_supports_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Cedula Legible</td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.colombian_id_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Antecedentes Fiscales expedido por la
                      Contraloría General de la República
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="
                          user.employee
                            .certificate_criminal_records_by_comptroller_url
                        "
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Antecedentes Fiscales Expedido por la
                      Procuraduría General de la República
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="
                          user.employee
                            .certificate_criminal_records_by_attorney_office_url
                        "
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Consulta de antecedentes Policía Nacional
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="
                          user.employee
                            .certificate_criminal_records_by_police_url
                        "
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Consulta de Medidas correctivas expedido
                      por la Policía Nacional
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="
                          user.employee
                            .certificate_corrective_measures_by_police_url
                        "
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificación Bancaria Actualizada 2022
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.certificate_bank_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Examen Médico Ocupacional vigente 2022
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.medical_exams_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Afiliación a EPS vigente 2022
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.certificate_eps_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      Certificado de Afiliación a AFP (pensión)
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.certificate_afp_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  
                  <tr>
                    <td class="text-left">
                      Redam
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.certificate_redam_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  
                  <tr>
                    <td class="text-left">
                      Delitos sexuales
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="blue"
                        :href="user.employee.certificate_sexual_url"
                        target="_blank"
                      >
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <note-show
          :notes="user.notes"
          :owner="user.id"
          type="PROFILE"
        ></note-show>
      </v-tab-item>
    </v-tabs-items>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          bottom
          right
          fixed
          color="green"
          v-bind="attrs"
          v-on="on"
          dark
          href="/profile/edit"
        >
          <v-icon> mdi-account-edit </v-icon>
        </v-btn>
      </template>
      <span>Editar</span>
    </v-tooltip>
  </div>
</template>

<script>
import { SET_USER } from "@/store/user";
import NoteShow from "@/components/note/Show";
export default {
  name: "Profile",
  components: {
    NoteShow,
  },
  data: () => ({
    tab: null,
    user: null,
  }),
  created() {
    if (this.$route.hash !== "") {
      this.tab = 3;
    }
    this.$store.dispatch("getUser");
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_USER) {
        this.user = state.user.user;
      }
    });
  },
};
</script>
<style scoped>
.profile {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
